import api from '@/api/resumeLockConfig'

const state = {

}

const actions = {
  getCompanyListCanConfig () {
    return api.getCompanyListCanConfig()
  },
  deleteApplicantLockConfig (context, companyId) {
    return api.deleteApplicantLockConfig(companyId)
  },
  createApplicantLockConfig (context, { companyId, configList }) {
    return api.createApplicantLockConfig(companyId, configList)
  },
  updateApplicantLockConfig (context, { companyId, configList }) {
    return api.updateApplicantLockConfig(companyId, configList)
  },
  getApplicantLockConfig (context, data) {
    return api.getApplicantLockConfig(data.companyId, data.params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
